export const FILE_REPOSITORY_PERMISSIONS = Object.freeze({
    open: 0x0001,
    modify: 0x0002,
    writeItems: 0x0004,
    writeFolders: 0x0008,
    alterPermissions: 0x0010,
    grantPermissions: 0x0020,
    alterOwnership: 0x0040,
});

export const FILE_REPOSITORY_PERMISSION_FIELDS = Object.freeze([
    { key: 'open', label: 'Open', value: FILE_REPOSITORY_PERMISSIONS.open },
    { key: 'modify', label: 'Modify', value: FILE_REPOSITORY_PERMISSIONS.modify },
    { key: 'writeItems', label: 'Write Items', value: FILE_REPOSITORY_PERMISSIONS.writeItems },
    { key: 'writeFolders', label: 'Write Folders', value: FILE_REPOSITORY_PERMISSIONS.writeFolders },
    { key: 'alterPermissions', label: 'Alter Permissions', value: FILE_REPOSITORY_PERMISSIONS.alterPermissions },
    { key: 'grantPermissions', label: 'Grant Permissions', value: FILE_REPOSITORY_PERMISSIONS.grantPermissions },
    { key: 'alterOwnership', label: 'Alter Ownership', value: FILE_REPOSITORY_PERMISSIONS.alterOwnership },
]);

export function getFileRepositoryPermissions(item) {
    return item?.permissions ?? 0;
}

export function hasFileRepositoryPermission(item, permission) {
    const permissions = getFileRepositoryPermissions(item);
    return (permissions & permission) === permission;
}

export function hasFileRepositoryPermissionValue(permissions, permission) {
    const numericPermissions = Number.isFinite(permissions) ? permissions : 0;
    return (numericPermissions & permission) === permission;
}

export function canOpenFileRepositoryItem(item) {
    return hasFileRepositoryPermission(item, FILE_REPOSITORY_PERMISSIONS.open);
}

export function canWriteFileRepositoryItems(item) {
    return hasFileRepositoryPermission(item, FILE_REPOSITORY_PERMISSIONS.writeItems);
}

export function canModifyFileRepositoryItem(item) {
    return hasFileRepositoryPermission(item, FILE_REPOSITORY_PERMISSIONS.modify);
}

export function canManageFileRepositoryItem(item) {
    return canWriteFileRepositoryItems(item);
}
